import { HTMLProps } from 'react'

export interface MdParaProps extends HTMLProps<HTMLParagraphElement> {
  inline: boolean
}

export const MdPara = ({ inline, className, children, ...rest }: MdParaProps) => {
  return (
    <div {...rest} className={`${inline ? 'inline' : ''} ${className ?? ''}`}>
      {children}
    </div>
  )
}
